import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Button } from 'seduo-ui';
class DocFullScreenExample extends React.Component {
    constructor(props) {
        super(props);
        this.handleToggle = () => {
            this.setState((prevState) => ({
                isOpen: !prevState.isOpen,
            }));
        };
        this.state = {
            isOpen: false,
        };
    }
    render() {
        const { children, container, containerFluid, className } = this.props;
        const { isOpen } = this.state;
        return (<Fragment>
                <div className={classNames('docs-example-full', {
                'd-block': isOpen,
            }, {
                'd-none': !isOpen,
            }, className)}>
                    <div className={classNames({
                container: container,
            }, {
                'container-fluid': containerFluid,
            })}>
                        {children}
                    </div>
                    <div className="mt-7 text-center">
                        <Button color="secondary" onClick={this.handleToggle}>
                            Close Fullscreen
                        </Button>
                    </div>
                </div>
                <div className="docs-example">
                    <Button onClick={this.handleToggle}>Show Fullscreen Example</Button>
                </div>
            </Fragment>);
    }
}
DocFullScreenExample.defaultProps = {
    container: false,
    containerFluid: false,
    className: '',
};
export default DocFullScreenExample;
